import { Link } from 'react-router-dom';
import MarketingFooter from '../components/MarketingFooter';
import MarketingNav from '../components/MarketingNav';

const focusRing =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-how-space-deep focus-visible:ring-offset-4';

export default function LandingPage() {
  return (
    <div className="min-h-screen overflow-x-hidden bg-landing-canvas">
      <section className="relative flex min-h-screen flex-col overflow-hidden">
        <img
          src="/backgroundoverlay.png"
          alt=""
          className="pointer-events-none absolute inset-0 h-full w-full object-cover object-top"
        />

        <MarketingNav actionLabel="Sign up" actionTo="/signup" />

        <main className="relative flex flex-1 flex-col items-center justify-center px-4 py-12 sm:py-16">
          <div className="relative z-10 flex flex-col items-center px-4 text-center">
            <h1 className="marketing-display-heading marketing-hero-heading flex flex-col items-center text-how-space-deep">
              <span>Act With</span>{' '}
              <img
                src="/homeimage.png"
                alt=""
                className="relative z-10 -my-4 h-48 w-64 rounded-3xl object-cover shadow-figure"
              />{' '}
              <span>Intention</span>
            </h1>

            <p className="mt-10 max-w-lg text-xl leading-relaxed text-landing-muted">
              <span className="block">Bring a decision you’re facing.</span>
              <span className="block">Howie helps you think it through.</span>
            </p>

            <div className="mt-8 flex items-center gap-5">
              <Link
                to="/signup"
                className={`inline-block whitespace-nowrap rounded-full bg-how-space-deep px-7 py-3 text-base text-how-paper-soft transition-colors hover:bg-how-space-mid sm:px-10 ${focusRing}`}
              >
                Sign up
              </Link>
              <Link
                to="/login"
                className={`inline-block whitespace-nowrap rounded-full bg-how-paper-soft px-7 py-3 text-base text-how-space-deep transition-colors hover:bg-how-paper-soft/80 sm:px-10 ${focusRing}`}
              >
                Sign in
              </Link>
            </div>

            <Link
              to="/companion/download"
              className={`mt-6 rounded-full text-sm text-landing-muted underline-offset-4 transition-colors hover:text-how-space-deep hover:underline ${focusRing}`}
            >
              Get Howie for your Mac
            </Link>
          </div>
        </main>

        <MarketingFooter />
      </section>
    </div>
  );
}
